import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"280px","width":"400px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw600 fs24 centered mt20",
    style: {"color":"#696969"}
  }, "連携しているカレンダーを最新のものに更新")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, [
    /*#__PURE__*/_createTextVNode(" カレンダーの表示が最新ではないですか？"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" こちらから最新のカレンダー情報を取得してきます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "orange fs12" }, " ※ 更新すると最大1時間、新たに追加したカレンダーはリアルタイムに反映されません。予めご了承ください。 ")
  ])
], -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "更新", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "RefreshCalendarModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll InputLocationModal"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
        }, _hoisted_8, 4)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("section", {
            id: "roomCloseButton",
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshCal && _ctx.refreshCal(...args)))
          }, _hoisted_13)
        ])
      ])
    ]),
    _: 1
  }))
}